__turbopack_context__.v({
  "exampleContent": "MethodCardContent-module-scss-module__zr3Beq__exampleContent",
  "exampleSection": "MethodCardContent-module-scss-module__zr3Beq__exampleSection",
  "exampleTitle": "MethodCardContent-module-scss-module__zr3Beq__exampleTitle",
  "method": "MethodCardContent-module-scss-module__zr3Beq__method",
  "parametersReturnsSection": "MethodCardContent-module-scss-module__zr3Beq__parametersReturnsSection",
});
